/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { __UNSAFE_SPACE_TO_DIMSUM, op, styled } from '@elliemae/ds-system';
import { DSFullPageContainer } from '../FullPageContainer/index.js';
import { BodyWrapper, Header, Section, Toolbar } from './Tags.js';

const Body = styled(Grid)`
  margin: 0 auto;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    ${({ theme }) => `width: ${op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xxl), 6.25)};`}
  }
`;

const PageSummary = ({
  header = null,
  headerZIndex = 1,
  bodyPrimary = null,
  actions = null,
  actionsZIndex = 1,
  bodySecondary = null,
}) => (
  <DSFullPageContainer>
    {header && <Header zIndex={headerZIndex}>{header}</Header>}
    <Section>
      <Grid>
        <Body>{bodyPrimary}</Body>
      </Grid>
      <Toolbar zIndex={actionsZIndex}>{actions}</Toolbar>
      <BodyWrapper>
        <Body>{bodySecondary}</Body>
      </BodyWrapper>
    </Section>
  </DSFullPageContainer>
);

const DSPageSummary = PageSummary;

export { DSPageSummary };
